import { useState } from "react";
import { useNavigate } from "react-router";
import { Dialog } from "../components/ui";
import { ApiError, post } from "../lib/api";

/**
 * The Friday stock check on the Clock screen: a pop-up while the cleaner is on site (or
 * just after clocking in or out), and a reminder card otherwise. It stops once they've sent
 * a request or said nothing is needed.
 */
export function FridayStockPrompt({
  siteId,
  popUp,
  onLater,
  onAnswered,
}: {
  /** The site they're clocked in at, if any. */
  siteId: string | null;
  /** Show as a pop-up (true) or just the reminder card. */
  popUp: boolean;
  onLater: () => void;
  onAnswered: () => void;
}) {
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function nothingNeeded() {
    setBusy(true);
    setError(null);
    try {
      await post("/stock/check", { siteId });
      onAnswered();
    } catch (e) {
      setError(e instanceof ApiError ? e.message : "Something went wrong. Please try again.");
    } finally {
      setBusy(false);
    }
  }

  const check = () => navigate("/stock?friday=1");

  return (
    <>
      <div className="banner info cl-stock-prompt">
        <span>
          <strong>Friday stock check.</strong> Do you need any top-ups?
        </span>
        <button className="btn sm primary" onClick={check}>
          Check stock
        </button>
      </div>
      {popUp && (
        <Dialog title="Friday stock check" onClose={onLater}>
          <p className="cl-lead cl-tight">Do you need any top-ups?</p>
          <p className="muted cl-tight">Bin bags, cleaning products, blue roll, or used cloths to collect.</p>
          {error && <div className="banner danger">{error}</div>}
          <button className="btn primary block" onClick={check} disabled={busy}>
            Yes, check what I need
          </button>
          <button className="btn block" onClick={nothingNeeded} disabled={busy}>
            {busy ? "Saving…" : "No, I have everything"}
          </button>
          <button className="btn ghost block" onClick={onLater} disabled={busy}>
            Ask me later
          </button>
        </Dialog>
      )}
    </>
  );
}
